import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IRiskLevel } from '@interfaces/riskLevels';
import { userDataSelector } from '@store/features/auth/user/selectors';
import { handleGetRiskLevels } from '@store/features/riskLevels/actions';
import {
  riskLevelsErrorSelector,
  riskLevelsIsLoadingSelector,
  riskLevelsIsReadySelector,
  riskLevelsSelector,
} from '@store/features/riskLevels/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useRiskLevels = (): IRiskLevel[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(riskLevelsSelector);
  const isLoading = useSelector(riskLevelsIsLoadingSelector);
  const isReady = useSelector(riskLevelsIsReadySelector);
  const error = useSelector(riskLevelsErrorSelector);
  const user = useSelector(userDataSelector);

  const handleFetch = useCallback(() => {
    !user?.isAdmin && user?.organizationId && dispatch(handleGetRiskLevels());
  }, [dispatch, user]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.riskLevelsError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useRiskLevels);
